module.exports = __webpack_public_path__ + "img/icon-facebook.d49f47a0.svg";